// src/pages/SignupPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signupUser } from '../api/authApi';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './SignupPage.css';

const SignupPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errors, setErrors] = useState({});
const [passwordMatchMessage, setPasswordMatchMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const validate = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = 'Please enter your name.';
    } else if (name.trim().length < 3) {
      newErrors.name = 'Name must be at least 3 characters.';
    }

    if (!email.trim()) {
      newErrors.email = 'Please enter your email address.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
  newErrors.email = 'Invalid email id';
}

if (!password) {
  newErrors.password = 'Please enter your password.';
} else if (password.length < 8) {
  newErrors.password = 'Password must be at least 8 characters.';
} else if (password.length > 64) {
  newErrors.password = 'Password cannot exceed 64 characters.';
}

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password.';
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match.';
    }

    if (!gender) {
      newErrors.gender = 'Please select your gender.';
    }

    if (!dob) {
      newErrors.dob = 'Please select your date of birth.';
    }

    return newErrors;
  };
    const handleSubmit = async (e) => {
    e.preventDefault();

        const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
            const normalizedEmail = email.trim().toLowerCase();

      await signupUser({
        name: name.trim(),
        email: normalizedEmail,
        password,
        confirm_password: confirmPassword,
        gender,
        dob: new Date(dob + 'T00:00:00Z').toISOString().split('T')[0],
        phone_number: phoneNumber.trim() || null
      });

      navigate('/verify-otp', { state: { email: normalizedEmail } });
    } catch (err) {
      const backendMessage =
        err?.data?.error ||
        err?.data?.message ||
        err?.message ||
        'Signup failed. Please try again.';

      const lowerMsg = backendMessage.toLowerCase();

      if (
        lowerMsg.includes('email') &&
        (lowerMsg.includes('already exists') ||
          lowerMsg.includes('already registered') ||
          lowerMsg.includes('exists'))
      ) {
        setErrors({ email: 'Email already registered.' });
      } else if (lowerMsg.includes('passwords must match')) {
        setErrors({ confirmPassword: 'Passwords do not match.' });
      } else {
        setErrors({ general: backendMessage });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="auth-page-header">
      <div className="brand" onClick={() => navigate("/")}>
      <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
      <span className="brand-text">CUSTOM ROAM</span>
      </div>
        <div className="back-home" onClick={() => navigate('/')}>
          Back to Home
        </div>
      </div>
  
      <div className="signup-container">
        <h2>Sign Up</h2>
        <form onSubmit={handleSubmit} className="signup-form">
                    <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (errors.name || errors.general) {
                setErrors((prev) => ({ ...prev, name: '', general: '' }));
              }
            }}
            required
            className="signup-input"
          />
          {errors.name && <p className="signup-error">{errors.name}</p>}
  
         <input
  type="text"
  placeholder="Email"
  value={email}
  onChange={(e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    if (errors.email || errors.general) {
      setErrors((prev) => ({ ...prev, email: '', general: '' }));
    }
  }}
  onBlur={() => {
    if (email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setErrors((prev) => ({ ...prev, email: 'Invalid email id' }));
    }
  }}
  required
  className="signup-input"
/>
{errors.email && <p className="signup-error">{errors.email}</p>}
  
<input
  type="password"
  placeholder="Password"
  maxLength={64}
            value={password}
            onChange={(e) => {
              const newPassword = e.target.value;
              setPassword(newPassword);
              let passwordError = '';

              if (newPassword.length > 0 && newPassword.length < 8) {
                passwordError = 'Password must contain at least 8 characters.';
              }
              setErrors((prev) => ({
                ...prev,
                password: '',
                confirmPassword: '',
                general: ''
              }));

              setPasswordMatchMessage('');
            }}
            required
            className="signup-input"
          />
          {errors.password && <p className="signup-error">{errors.password}</p>}
  
          <input
  type="password"
  placeholder="Confirm Password"
  maxLength={64}
            value={confirmPassword}
            onChange={(e) => {
              const newConfirmPassword = e.target.value;
              setConfirmPassword(newConfirmPassword);

              setErrors((prev) => ({
                ...prev,
                confirmPassword: '',
                general: ''
              }));

              if (newConfirmPassword.length > 0) {
                if (password === newConfirmPassword) {
                  setPasswordMatchMessage('Passwords match ✓');
                } else {
                  setPasswordMatchMessage('Passwords do not match.');
                }
              } else {
                setPasswordMatchMessage('');
              }
            }}
            required
            className="signup-input"
          />
          {errors.confirmPassword && (
            <p className="signup-error">{errors.confirmPassword}</p>
          )}

          {!errors.confirmPassword && passwordMatchMessage && (
            <p
              className={`signup-password-match ${
                passwordMatchMessage === 'Passwords match ✓' ? 'success' : 'error'
              }`}
            >
              {passwordMatchMessage}
            </p>
          )}
  
                   <select
            value={gender}
            onChange={(e) => {
              setGender(e.target.value);
              if (errors.gender || errors.general) {
                setErrors((prev) => ({ ...prev, gender: '', general: '' }));
              }
            }}
            required
            className="signup-select"
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          {errors.gender && <p className="signup-error">{errors.gender}</p>}
  
                    <div className={`date-wrapper ${dob ? 'has-value' : ''}`}>
            <label className="date-label">Date of Birth</label>
            <input
              type="date"
              value={dob}
              onChange={(e) => {
                setDob(e.target.value);
                if (errors.dob || errors.general) {
                  setErrors((prev) => ({ ...prev, dob: '', general: '' }));
                }
              }}
              required
              className="signup-input date-input"
            />
          </div>
          {errors.dob && <p className="signup-error">{errors.dob}</p>}

  
          <div className="signup-phone-wrapper">
  <label className="signup-phone-label">Phone Number (optional)</label>

  <PhoneInput
    international
    defaultCountry="US"
    countryCallingCodeEditable={false}
    placeholder="Phone Number"
    value={phoneNumber}
    onChange={(value) => {
      setPhoneNumber(value || '');

      if (errors.general) {
        setErrors((prev) => ({ ...prev, general: '' }));
      }
    }}
    className="signup-phone-input"
  />
</div>
  
          {errors.general && <p className="signup-error">{errors.general}</p>}
  
          <button type="submit" disabled={loading} className="signup-button">
            {loading ? 'Signing up...' : 'Sign Up'}
          </button>
  
          <p className="login-redirect-text">
            Already have an account?{' '}
            <Link to="/login" className="login-link">Log in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}  

export default SignupPage;
